module.exports = __webpack_public_path__ + "img/map_marker.363d18f4.svg";